export enum LicenseStatus {
  VALID = 'VALID',
  BLOCKED = 'BLOCKED',
  TERMINATED = 'TERMINATED',
}

export const LICENSE_STATUS_LABELS: Record<LicenseStatus, string> = {
  [LicenseStatus.VALID]: 'Valide',
  [LicenseStatus.BLOCKED]: 'Bloquée',
  [LicenseStatus.TERMINATED]: 'Résiliée',
}
